(function () {
  /** @type {HTMLFormElement | null} */
  const form = document.querySelector('[data-coming-soon-form]');
  if (!form) return;

  const companyId = form.dataset.klaviyoCompanyId;
  const listId = form.dataset.klaviyoListId;
  /** @type {HTMLInputElement | null} */
  const emailInput = form.querySelector('[data-coming-soon-email]');
  /** @type {HTMLButtonElement | null} */
  const submitButton = form.querySelector('[data-coming-soon-submit]');
  /** @type {HTMLElement | null} */
  const errorEl = form.querySelector('[data-coming-soon-error]');
  /** @type {HTMLElement | null} */
  const successEl = form.querySelector('[data-coming-soon-success]');

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  let errorTimer = null;

  const setMessage = (el, text) => {
    if (!el) return;
    el.hidden = !text;
    el.textContent = text;
  };

  const clearErrors = () => {
    if (errorTimer) {
      clearTimeout(errorTimer);
      errorTimer = null;
    }
    setMessage(errorEl, '');
    if (emailInput) {
      emailInput.removeAttribute('aria-invalid');
      emailInput.removeAttribute('aria-describedby');
    }
  };

  const showError = (message) => {
    if (errorTimer) {
      clearTimeout(errorTimer);
      errorTimer = null;
    }
    setMessage(successEl, '');
    setMessage(errorEl, message);
    if (emailInput) {
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.setAttribute('aria-describedby', 'ComingSoonEmail-error');
      emailInput.focus();
    }
    errorTimer = setTimeout(clearErrors, 4000);
  };

  const showSuccess = (message) => {
    clearErrors();
    setMessage(successEl, message);
    if (emailInput) {
      emailInput.setAttribute('aria-describedby', 'ComingSoonEmail-success');
    }
  };

  emailInput?.addEventListener('input', () => {
    if (emailInput.getAttribute('aria-invalid') === 'true') {
      clearErrors();
    }
  });

  emailInput?.addEventListener('blur', () => {
    if (emailInput.getAttribute('aria-invalid') === 'true') {
      clearErrors();
    }
  });

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    clearErrors();
    setMessage(successEl, '');

    if (!companyId || !listId) {
      showError('Signup is not configured yet. Please try again later.');
      return;
    }

    const email = emailInput?.value?.trim() ?? '';
    if (!email) {
      showError('Please enter your email address.');
      return;
    }

    if (!emailPattern.test(email)) {
      showError('Please enter a valid email address.');
      return;
    }

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(companyId)}`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            revision: '2025-01-15',
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Coming Soon page',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: 'SUBSCRIBED',
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: listId,
                  },
                },
              },
            },
          }),
        }
      );

      if (response.ok) {
        form.reset();
        showSuccess("Thanks - you're on the list.");
        return;
      }

      showError('Something went wrong. Please try again.');
    } catch {
      showError('Something went wrong. Please try again.');
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
      }
    }
  });
})();
